module.exports = __webpack_public_path__ + "static/media/Logo.61063b29.png";